// removed by extract-text-webpack-plugin
module.exports = {"listLabels":"ListLabels-listLabels--3IQd9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataPanel/Overview/ListLabels/ListLabels.scss
// module id = fUSz
// module chunks = 4